interface MapDirectionsOptions {
  attractionName: string;
  attractionLat: number;
  attractionLng: number;
  onDenied?: () => void;
  onError?: () => void;
}

export function getDirections({
  attractionName,
  attractionLat,
  attractionLng,
  onDenied,
  onError,
}: MapDirectionsOptions): void {
  const encodedName = encodeURIComponent(attractionName);
  const destinationQuery = `${attractionLat},${attractionLng}(${encodedName})`;

  if ('geolocation' in navigator) {
    navigator.geolocation.getCurrentPosition(
      (position) => {
        const { latitude: userLat, longitude: userLng } = position.coords;
        console.log(`https://www.google.com/maps/dir/?api=1&origin=${userLat},${userLng}&destination=${attractionLat},${attractionLng}`)
        openMapsUrl(`https://www.google.com/maps/dir/?api=1&origin=${userLat},${userLng}&destination=${attractionLat},${attractionLng}`, attractionLat, attractionLng, attractionName);
      },
      (err) => {
        // Permission denied or timeout — open maps with destination only
        console.log('Geolocation denied or timeout, opening maps with destination only');
        openMapsUrl(`https://www.google.com/maps/dir/?api=1&destination=${destinationQuery}`, 0, 0, attractionName);
      },
      { timeout: 5000, enableHighAccuracy: false }
    );
  } else {
    // No geolocation support — open maps with destination only
    console.log(`https://www.google.com/maps/dir/?api=1&destination=${destinationQuery}`)
    openMapsUrl(`https://www.google.com/maps/dir/?api=1&destination=${destinationQuery}`, 0, 0, attractionName);
  }
}

function openMapsUrl(url: string, latitude: number, longitude: number, attractionName: string): void {
  const isMobile = /iPhone|iPad|iPod|Android/.test(navigator.userAgent);

  if (isMobile) {
    // Extract destination from URL
    const match = url.match(/destination=([^&]+)/);
    const dest = match ? decodeURIComponent(match[1]) : url;
    const latLng = dest.replace(/\([^)]*\)/g, '').trim();
    const encodedLatLng = encodeURIComponent(latLng);

    // Try native Google Maps app first (works on iOS if installed)
    let nativeUrl = `comgooglemaps://?daddr=${encodedLatLng}&directionsmode=driving`;
    if (latitude !== 0 && longitude !== 0) {
      nativeUrl = `comgooglemaps://?center=${latitude},${longitude}&q=${encodeURIComponent(attractionName)}`;
    }

    console.log('Starting openMapsUrl')

    const start = Date.now();
    const timeout = setTimeout(() => {
      console.log(`Time Out? - ${Date.now() - start}`);
      if (Date.now() - start > 2000) {
        console.log('Time Out!')
        // window.location.href = webUrl;
      }
    }, 1000);

    console.log('Native URL ' + nativeUrl)
    const anchor = document.createElement('a');
    // anchor.style.display = 'none';
    anchor.href = nativeUrl;
    anchor.rel = 'noreferrer noopener';
    document.body.appendChild(anchor);
    anchor.click();
    // document.body.removeChild(anchor);

    // Clean up timeout if the app opens
    const checkOpen = setInterval(() => {
      console.log('clearInterval - ' + document.hidden + ' - ' + (Date.now() - start))
      if (document.hidden || Date.now() - start > 3000) {
        console.log('clearInterval - ' + document.hidden + ' - ' + (Date.now() - start))
        clearInterval(checkOpen);
        console.log('clearTimeout')
        clearTimeout(timeout);
        console.log('Done')
      }
    }, 500);
  } else {
    // Desktop: open in new tab
    console.log('Desktop URL')
    window.open(url, '_blank', 'noopener,noreferrer');
  }
}